import { ReactNode } from 'react';

import Avatar from '@/common/components/Avatar/Avatar';
import Badge from '@/common/components/Badge/Badge';
import { ResolutionsSrcSet } from '@/common/constants/displateRoutes';
import { PopupRaw } from '@/common/styleguide/molecules/Popup/Popup';
import { HomepageUpcomingEventV2 } from 'generatedBfw/static';

import styles from './comingSoonPopup.module.scss';
import ComingSoonPopupDate from './ComingSoonPopupDate';

interface Props {
  event: HomepageUpcomingEventV2;
  onClose: () => void;
  slotBottom?: ReactNode;
}

const ComingSoonPopup = ({ event, slotBottom, onClose }: Props) => {
  return (
    <PopupRaw className={styles.popup} dataTestId="coming-soon-popup" onClose={onClose}>
      <div className={styles.popupContentContainer}>
        <div className={styles.badgeContainer} data-testid="coming-soon-popup-badge">
          {event.badge ? <Badge type={event.badge} /> : null}
        </div>
        <h3 className={styles.title} data-testid="coming-soon-popup-title">
          {event.title}
        </h3>
        {event.author ? (
          <Avatar author={event.author} className={styles.author} showName size="small" />
        ) : null}
        <picture className={styles.picture}>
          <source
            srcSet={ResolutionsSrcSet({
              x1: event.files.teaserStandard,
              x2: event.files.teaserRetina,
            })}
          />
          <img
            alt={event.title}
            className={styles.image}
            data-testid="coming-soon-popup-teaser-image"
            height={280}
            src={event.files.teaserStandard}
            width={432}
          />
        </picture>
        <div className={styles.description} data-testid="coming-soon-popup-description">
          <span dangerouslySetInnerHTML={{ __html: event.description }}></span>
        </div>
        <ComingSoonPopupDate className={styles.date} date={event.startsAt} />
        {slotBottom ? <div className={styles.slotBottom}>{slotBottom}</div> : null}
      </div>
    </PopupRaw>
  );
};

export default ComingSoonPopup;
